(function () {
  'use strict';

  if (window.LSZeroPriceHideV2Loaded) return;
  window.LSZeroPriceHideV2Loaded = true;

  var priceSelector = '.t4s-product-price, [data-pr-price], [data-product-price], [data-sticky-price]';

  function isZeroPrice(element) {
    var salePrice = element.querySelector('ins');
    var source = salePrice || element.cloneNode(true);

    if (!salePrice) {
      source.querySelectorAll('del, .t4s-badge-price').forEach(function (item) {
        item.remove();
      });
    }

    var value = source.textContent.match(/\d[\d,]*(?:\.\d+)?/);
    if (value) return Number(value[0].replace(/,/g, '')) === 0;

    var rawPrice = element.getAttribute('data-ls-price-cents');
    return rawPrice !== null && rawPrice !== '' && Number(rawPrice) === 0;
  }

  function updatePrice(element) {
    if (!element || !element.matches(priceSelector)) return;
    element.classList.toggle('ls-zero-price-hidden', isZeroPrice(element));
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    updatePrice(root);
    root.querySelectorAll(priceSelector).forEach(updatePrice);
  }

  function initialize() {
    scan(document.body);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(scan);
        scan(mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement);
      });
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
